import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IRulesPerBINDataTableRowFormMeta {  
  bin: FormInputMeta,
  command: FormInputMeta,
  reason: FormInputMeta,

  // Schema
  schema: any,
}

const RulesPerBINDataTableRowFormMeta = {} as IRulesPerBINDataTableRowFormMeta;

RulesPerBINDataTableRowFormMeta.bin = {
  name: "bin",
  label: "BIN",
  type: "select",
  options:  [
    {
      label: 'BIN A',
      value: 'a'
    },
    {
      label: 'BIN B',
      value: 'b',
    },
    {
      label: 'BIN C',
      value: 'b',
    },
  ],
  validation: yup.string().required(),
};
RulesPerBINDataTableRowFormMeta.command = {
  name: "command",
  label: "Commande",
  type: "select",
  options:  [
    {
      label: 'Commande A',
      value: 'a'
    },
    {
      label: 'Commande B',
      value: 'b',
    },
    {
      label: 'Commande C',
      value: 'b',
    },
  ],
  validation: yup.string().required(),
};
RulesPerBINDataTableRowFormMeta.reason = {
  name: "reason",
  label: "Motif",
  type: "select",
  options:  [
    {
      label: 'Motif A',
      value: 'a'
    },
    {
      label: 'Motif B',
      value: 'b',
    },
    {
      label: 'Motif C',
      value: 'b',
    },
  ],
  validation: yup.string().required(),
};

RulesPerBINDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(RulesPerBINDataTableRowFormMeta));

export default RulesPerBINDataTableRowFormMeta;